import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { GroupResult } from '@progress/kendo-data-query';
import { UserMiniDto } from '@unity/clients';
import { DropdownClickableControlComponent } from '@unity/forms/dropdown-clickable-control/dropdown-clickable-control.component';

@Component({
  selector: 'unity-dropdown-user-assign-control',
  standalone: true,
  imports: [ReactiveFormsModule, DropdownClickableControlComponent],
  templateUrl: './dropdown-user-assign-control.component.html',
  styleUrl: './dropdown-user-assign-control.component.scss',
})
export class DropdownUserAssignControlComponent {
  public readonly $control = input.required<FormControl>({ alias: 'control' });
  public readonly $selectable = input.required<(GroupResult | UserMiniDto)[]>({ alias: 'selectable' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });
}
